import { render, staticRenderFns } from "./SpecialPriceAdjNew_Items.vue?vue&type=template&id=1633bff4&"
import script from "./SpecialPriceAdjNew_Items.vue?vue&type=script&lang=js&"
export * from "./SpecialPriceAdjNew_Items.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports